export const getCityList = (state) => state.dict.cityList;
export const getSubjectList = (state) => state.dict.subjectList;
export const getRetailBusinessItems = (state) => state.dict.retail.businessItems;
export const getRetailBusinessPriceRange = (state) => state.dict.retail.businessPriceRange;
export const getSelfBusinessItems = (state) => state.dict.self.businessItems;
export const getPromBusinessItems = (state) => state.dict.prom.businessItems;
export const getPromConceptItem = (state) => state.dict.prom.conceptItem;
